import { LayoutList, LayoutGrid } from "lucide-react";
import type { ListView } from "@/hooks/useListView";

/** Interruttore Tabella/Card — visibile solo su desktop (su mobile le liste sono sempre a card). */
export function ListViewToggle({ view, onChange }: { view: ListView; onChange: (v: ListView) => void }) {
  const btn = (v: ListView, label: string, Icon: typeof LayoutList) => (
    <button
      type="button"
      onClick={() => onChange(v)}
      aria-label={label}
      aria-pressed={view === v}
      title={label}
      className={
        "px-2.5 py-2 transition-colors " +
        (view === v ? "bg-brand text-white" : "bg-card text-muted-foreground hover:bg-surface")
      }
    >
      <Icon size={16} />
    </button>
  );
  return (
    <div data-tour="lista-vista" className="hidden sm:flex items-center rounded-lg border border-border overflow-hidden">
      {btn("table", "Vista tabella", LayoutList)}
      {btn("card", "Vista card", LayoutGrid)}
    </div>
  );
}
